<div class="nha-container-full nha-gray-bg">
	<div class="nha-pattern-school nha-green-bg nha-span-full"></div>
	<div class="nha-sa-container print-container">
		<div *ngIf="!showHowHeard; else howHeard">
			<div *ngIf="showSchoolPicker && schoolList" class="nha-row">
				<div class="nha-form-group nha-input-select nha-gr-12 nha-gr-8@sm nha-gr-6@md">
					<label class="remove-for-print" for="school-picker">Select a School</label>
					<select id="school-picker" class="nha-form-control remove-for-print" [(ngModel)]="schoolID" (change)="getContent()">
						<option></option>
						<option *ngFor="let school of schoolList" [ngValue]="school.schoolID">
							{{ school.schoolName }}
						</option>
					</select>
				</div>
			</div>
			<div *ngIf="!isSubmitted; else showSubmittedPage">
				<div *ngIf="content$ | async as appContent; else loading">
					<div class="nha-sa-title">
						<div class="nha-pre-header">
							{{ appContent.resourceStrings['nha.sa.studenttitle'] }}
						</div>
						<h1 class="nha-primary-heading remove-for-print">
							{{ appContent.resourceStrings['nha.sa.applicationtitle'] }}
						</h1>

						<div class="print-school-info">
							<h3>
								{{ appContent.schoolName }} -
								{{ appContent.resourceStrings['nha.sa.applicationtitle'] }}
							</h3>
							<div>
								{{ appContent.fullAddress }}
							</div>
							<div>{{ appContent.phone }} {{ appContent.email }}</div>
						</div>

						<div class="remove-for-print">
							<div *ngIf="appContent.schoolID === 497 || appContent.schoolID === 508" class="nha-text-center">
								Westfield Charter Academy (K-6)<br />
								Westfield Prep (7-12)
							</div>
							<br />
							<div *ngIf="IsPlacementTestSchool(appContent.schoolID)">
								<div
									class="nha-sa-pembroke-info nha-text-center"
									(click)="openPembrokeInfoModal()"
									href="#pembroke-info-modal"
									[innerHTML]="appContent.resourceStrings['nha.sa.pembrokedidyouknow']"
								></div>
								<div class="nha-text-center" [innerHTML]="appContent.resourceStrings['nha.sa.whattoexpectpembroke']"></div>
								<div id="pembroke-info-modal" style="display: none" [innerHTML]="appContent.resourceStrings['nha.sa.pembrokeinfomodal']"></div>
							</div>
							<div *ngIf="IsWillowForPlacement(appContent.schoolID)">
								<div
									class="nha-sa-willow-info nha-text-center"
									(click)="openWillowInfoModal()"
									href="#willow-info-modal"
									[innerHTML]="appContent.resourceStrings['nha.sa.willowdidyouknow']"
								></div>
								<div class="nha-text-center" [innerHTML]="appContent.resourceStrings['nha.sa.whattoexpectpembroke']"></div>
								<div id="willow-info-modal" style="display: none" [innerHTML]="appContent.resourceStrings['nha.sa.willowinfomodal']"></div>
							</div>
							<div *ngIf="!IsPlacementTestSchool(appContent.schoolID) && !IsWillowForPlacement(appContent.schoolID)">
								<div class="nha-text-center" [innerHTML]="appContent.resourceStrings['nha.sa.whattoexpectbeginning']"></div>
							</div>
						</div>
					</div>
					<div>
						<div class="first-page-print">
							<app-academic-year></app-academic-year>
							<app-guardian></app-guardian>
						</div>
						<div class="page-print">
							<app-child></app-child>
							<app-nearby-schools *ngIf="appContent.schoolID !== 497 && appContent.schoolID !== 508"> </app-nearby-schools>
						</div>
						<app-terms-conditions [showTermsAndConditions]="showTermsAndConditions"></app-terms-conditions>
					</div>
					<div class="nha-sa-section-callout">
						<button class="nha-btn nha-btn-secondary" type="submit" (click)="submitApplicationClick()" [disabled]="isSaving">
							<span *ngIf="!isSaving">{{ appContent.resourceStrings['nha.sa.submitapplicationbutton'] }}</span>
							<span *ngIf="isSaving" class="nha-loading"><div></div></span>
						</button>
					</div>
					<div id="print-link-scrollto" class="nha-text-center remove-for-print">
						Download a
						<a (click)="printApplication()" (keyup.enter)="printApplication()" tabindex="0">printable version of the application</a>.
					</div>
					@if (appContent.authorizerName) {
						<div class="authorizer-statement">
							{{ appContent.schoolName }} is managed by National Heritage Academies and authorized by {{ appContent.authorizerName }}
						</div>
					}
				</div>
				<ng-template #loading>
					<h2 *ngIf="loadError">Oops! We had an error trying to load the student application. Please try reloading the page.</h2>
					<div *ngIf="!loadError" class="nha-loading"><div></div></div>
				</ng-template>
			</div>
			<ng-template #showSubmittedPage>
				<app-submitted [appData]="appData" [uniqueHouseholds]="uniqueHouseholds"></app-submitted>
			</ng-template>
		</div>
		<ng-template #howHeard>
			<app-how-heard></app-how-heard>
		</ng-template>
	</div>
</div>
